// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1nUpp","question":"Question_question__1Jy5-","description":"Question_description__CnGzt"};